import React, { useState } from "react";
import { GridColumnMenuSort } from "@progress/kendo-react-grid";
import { Input } from "@progress/kendo-react-inputs";

export const ColumnMenuClaim = (props) => {
    const [value, setValue] = useState("");

    //const applyFilter = () => {
    //    const filter = {
    //        logic: "and",
    //        filters: [
    //            {
    //                field: props.column.field,
    //                operator: "contains",
    //                value: value || ""
    //            }
    //        ]
    //    };

    //    // THIS is the key change
    //    props.onFilterChange({
    //        nextFilter: filter
    //    });

    //    props.onCloseMenu();
    //};

    //const clearFilter = () => {
    //    setValue("");

    //    props.onFilterChange({
    //        nextFilter: null
    //    });

    //    props.onCloseMenu();
    //};

    return (
        <div style={{ width: 220, padding: 8 }}>
            <GridColumnMenuSort {...props} />

            {/*<hr />*/}

            {/*<Input*/}
            {/*    placeholder="Contains..."*/}
            {/*    value={value}*/}
            {/*    onChange={(e) => setValue(e.value)}*/}
            {/*    onKeyDown={(e) => {*/}
            {/*        if (e.key === "Enter") {*/}
            {/*            applyFilter();*/}
            {/*        }*/}
            {/*    }}*/}
            {/*/>*/}

            {/*<div*/}
            {/*    style={{*/}
            {/*        marginTop: 10,*/}
            {/*        display: "flex",*/}
            {/*        gap: 8,*/}
            {/*        justifyContent: "flex-end"*/}
            {/*    }}*/}
            {/*>*/}
            {/*    <button*/}
            {/*        className="k-button k-button-md k-rounded-md"*/}
            {/*        onClick={clearFilter}*/}
            {/*    >*/}
            {/*        Clear*/}
            {/*    </button>*/}

            {/*    <button*/}
            {/*        className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-primary"*/}
            {/*        onClick={applyFilter}*/}
            {/*    >*/}
            {/*        Filter*/}
            {/*    </button>*/}
            {/*</div>*/}
        </div>
    );
};